import { render, staticRenderFns } from "./add-contact-category.vue?vue&type=template&id=77e9d322&scoped=true"
import script from "./add-contact-category.vue?vue&type=script&lang=js"
export * from "./add-contact-category.vue?vue&type=script&lang=js"
import style0 from "./add-contact-category.vue?vue&type=style&index=0&id=77e9d322&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e9d322",
  null
  
)

export default component.exports